<template>
  <b-card class="mb-0" no-body>
    <template #footer>
      <strong>Users</strong>
      {{ data.length }}/{{ listQuery.count }}
      <loader :loading="listQuery.loading" color="#37a9e1" size="16px"></loader>
    </template>

    <b-card-body>
      <b-input-group>
        <input
          v-model="listQuery.search"
          class="form-control"
          placeholder="Search users..."
          type="text"
          @keyup="search"
        />

        <div class="searching-spinner">
          <loader :loading="listQuery.loading" color="#37a9e1" size="16px"></loader>
        </div>

        <b-input-group-append v-if="false">
          <button class="btn btn-primary" type="button" @click.prevent="toggleAdvancedSearch">
            <font-awesome-icon v-if="advancedSearch" :icon="['fal', 'chevron-up']" />
            <font-awesome-icon v-else :icon="['fal', 'chevron-down']" />
          </button>
        </b-input-group-append>

        <button class="btn btn-outline-danger ml-1" type="button" @click.prevent="reset">
          <font-awesome-icon :icon="['fal', 'undo']" />
        </button>
      </b-input-group>

      <div v-if="false" v-show="advancedSearch">
        <div class="mt-2">
          <select v-model="listQuery.brandId" class="form-control" @change="immediateSearch">
            <option :value="null">Brand</option>
            <option v-for="brand in allBrandData" :key="brand.id" :value="brand.id">
              {{ brand.name }}
            </option>
          </select>
        </div>

        <div class="mt-2">
          <div>
            <span class="advanced-switch">
              <template v-if="ascending">Ascending</template>
              <template v-else>Descending</template>
            </span>
            <core-switch
              v-model="ascending"
              class="float-right"
              color="primary"
              off="D"
              on="A"
              variant="3d"
              @change="immediateSearch"
            />
          </div>
        </div>
      </div>
    </b-card-body>

    <!-- Not using b-list-group because it seems to break v-infinite-scroll -->
    <ul
      ref="userList"
      class="list-group list-group-flush overflow-y-auto user-list"
      style="height: 708px"
    >
      <li
        v-for="user in data"
        :key="user.id"
        :class="[user.id === selectedUserId ? 'active' : '']"
        class="list-group-item cursor pt-2 pb-1"
        @click="clicked(user)"
      >
        <img
          :alt="user.name"
          :src="user.profile_photo ? user.profile_photo : profileDefault"
          class="rounded-circle mr-2"
          width="30"
        />
        <span class="user-name">{{ user.name }}</span>
      </li>
    </ul>

    <div v-if="false" class="search-dimmer">
      <loader color="#37a9e1" size="16px"></loader>
    </div>
  </b-card>
</template>

<script type="text/babel">
import debounce from "debounce";
import loader from "vue-spinner/src/ClipLoader.vue";

export default {
  components: {
    loader,
  },

  props: {
    createAction: {
      type: Function,
      required: false,
    },

    clickAction: {
      type: Function,
      required: false,
    },

    query: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      profileDefault:
        "data:image/png;base64,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",

      initialised: false,
      allBrandData: [],
      advancedSearch: false,
      ascending: false,
      selectedUserId: null,

      listQuery: {},

      data: [],
    };
  },

  async mounted() {
    this.init();

    await this.loadList();
    // this.allBrandData = await this.$store.dispatch("brands/getData");
  },

  methods: {
    async loadList() {
      this.listQuery.loading = true;

      const params = Object.assign(
        {
          search: this.$lodash.get(this.listQuery, "search", ""),
          page: this.$lodash.get(this.listQuery, "page", 1),
          sortedBy: this.$lodash.get(this.listQuery, "order", "desc"),
          brandId: this.$lodash.get(this.listQuery, "brandId"),
          orderBy: "id",
          with: "",
          limit: 9999,
        },
        this.query
      );

      const response = await this.$http.get("/users", {
        params,
      });

      this.data = response.body.data;

      this.listQuery.loading = false;
      this.listQuery.count = response.body.total;
    },

    init() {
      this.initialised = false;
      this.selectedUserId = null;
      this.advancedSearch = false;
      this.ascending = false;
      this.initialised = true;
    },

    async reset() {
      this.init();

      await this.loadList();

      this.$emit("reset");
    },

    create() {
      if (typeof this.createAction === "function") {
        this.createAction();
      }
    },

    clicked(user) {
      this.selectedUserId = user.id;

      if (typeof this.clickAction === "function") {
        this.clickAction(user);
      }
    },

    async loadMore() {},

    /* eslint-disable func-names */
    search: debounce(async function () {
      if (this.listQuery.search.length < 2 && this.listQuery.search.length !== 0) {
        return;
      }

      this.listQuery.loading = true;
      this.listQuery.page = 1;

      await this.loadList();
    }, 500),

    async immediateSearch() {
      if (!this.$lodash.has(this.listQuery, "search")) {
        return;
      }
      if (this.listQuery.search.length < 2 && this.listQuery.search.length !== 0) {
        return;
      }

      this.listQuery.order = this.ascending ? "asc" : "desc";
      this.listQuery.page = 1;

      await this.loadList();
    },

    toggleAdvancedSearch() {
      this.advancedSearch = !this.advancedSearch;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.card-body {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-item {
  border-top: 0;
  margin-bottom: 0;
}

.list-group-item > div:not(:last-child) {
  margin-bottom: 12px;
}

.advanced-switch {
  line-height: 35px;
}

.searching-spinner {
  position: absolute;
  right: 92px;
  top: 3px;
  font-size: 18px;
  z-index: 9999;
}

.search-dimmer {
  position: absolute;
  z-index: 9999;
  width: 100%;
  height: 667px;
  top: 76px;
  left: 0;
  text-align: center;
  background: #fff;
  opacity: 0.5;
  transition: all 0.5s;
}

.user-list {
  .list-group-item {
    width: 100%;
    padding: 0 10px;
    color: #868282;

    &:hover:not(.active) {
      background-color: #ececec;
      transition: background-color 200ms linear;
    }

    .user-name {
      color: #23282c;
    }

    &.active {
      border-top: 0;
      border-bottom: 0;

      color: #fff;

      .user-name {
        color: #fff;
      }
    }
  }

  .wrapper {
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  .multiselect__tag {
    margin-right: 4px;
  }
}

body.dark .user-list {
  .user-name {
    color: #e4e7ea;
  }
}

::v-deep .multiselect__tags {
  padding-left: 15px;
  padding-right: 15px;
}

::v-deep .multiselect__single {
  overflow-x: hidden;
}

::v-deep .multiselect__content-wrapper {
  overflow-x: hidden;
}

::v-deep .multiselect__option--group {
  font-weight: bold;
  color: #fff;
  background-color: #36a9e1;
}
</style>
